import { ChatProvider } from './providers/types';
import { zendeskProvider } from './providers/ZendeskProvider';

function getChatProvider(useZendesk: boolean): ChatProvider | null {
  if (useZendesk && zendeskProvider.isAvailable()) {
    return zendeskProvider;
  }

  return null;
}

/**
 * Initializes the chat service with the appropriate provider.
 * @param email - User's email address
 * @param enableZendeskChat - Feature flag to enable Zendesk
 */
export async function startChat(email: string, enableZendeskChat = false): Promise<void> {
  const provider = getChatProvider(enableZendeskChat);

  if (!provider) {
    return;
  }

  try {
    await provider.start(email);
  } catch {
    // Silent fail - user will not have chat available
  }
}

/**
 * Hides the Zendesk widget bubble.
 */
export function hideZendeskWidget(): void {
  zendeskProvider.hide();
}

/**
 * Shows the Zendesk widget bubble.
 */
export function showZendeskWidget(): void {
  zendeskProvider.show();
}

export type { ChatProvider } from './providers/types';
